/** Version differences are informational; existing results cannot be re-evaluated. */
import { AlertTriangle } from "lucide-react";
import type { Comparison } from "./types";
import { gapSentence, versionGaps } from "./versions";

export function VersionWarning({ data }: { data: Comparison }) {
  const gaps = versionGaps(data.evaluators, data.experiments);
  if (!gaps.length) return null;
  return (
    <ul
      role="list"
      aria-label="Evaluator versions differ"
      className="flex flex-col divide-y divide-warn/15 rounded-lg bg-warn-bg text-warn"
    >
      {gaps.map((gap) => (
        <li key={gap.evaluator.key} className="flex flex-wrap items-center gap-3 px-4 py-2.5">
          <AlertTriangle size={14} aria-hidden />
          <span className="grow text-[13px]">
            {gapSentence(gap)}. Create new experiments with matching evaluator versions to compare their
            scores.
          </span>
        </li>
      ))}
    </ul>
  );
}
